// import React, { Component } from 'react';
// import {  Button, InputGroup,FormControl,Table,Container } from 'react-bootstrap';
// import axios from 'axios';
// import {  Loading } from '../../helpers';
// const admin = require('firebase');
// // var config = {
// //   apiKey: "AIzaSyCKbZoY6c-9V9Ymzjwe_wa5GZ3n8e2x45s",
// //   authDomain: "riceinspectioninsea.firebaseapp.com",
// //   databaseURL: "https://riceinspectioninsea.firebaseio.com",
// //   projectId: "riceinspectioninsea",
// //   storageBucket: "riceinspectioninsea.appspot.com",
// //   messagingSenderId: "850193313964",
// //   appId: "1:850193313964:web:ec67cea88d08ccbfa76f09"
// // }

// class UploadCheckWeight extends Component {

//     constructor(props) {
//         super(props);
//         this.state = { 
//             file: null,
//             jobID : '',
//             licenseID : '',
//             dataArr : [],
//             isLoading : false,
//         };
//         this.handleChange = this.handleChange.bind(this);
//         this.handleInput = this.handleInput.bind(this);
//         this.uploadToFirebase = this.uploadToFirebase.bind(this);
//     }

//     handleChange(event) {
//         const file = event.target.files[0]
//         this.setState({
//             ...this.state,
//             file : file,
//         })
//         // EXIF.getData(files[0], function () {
//         //     var orientation = EXIF.getTag(this, "Orientation");
//         //     let rotatePic = 0;
//         //     switch (orientation) {
//         //       case 8:
//         //         rotatePic = 270;
//         //         break;
//         //       case 6:
//         //         rotatePic = 90;
//         //         break;
//         //       case 3:
//         //         rotatePic = 180;
//         //         break;
//         //       default:
//         //         rotatePic = 0;
    
//         //     }
//         //     that.setState({ 
//         //         ...this.state,
//         //         file : file,
//         //      });
//         //   });
    
//     }
//     handleInput(e){
//         this.setState({
//             ...this.state,
//             [e.target.id] : e.target.value
//         })
//     }
//     uploadToFirebase() {
//         if(this.state.file){
//             const storageRef = admin.storage().ref()
//             this.setState({
//                 ...this.state,
//                 isLoading : true,
//             })    
//             storageRef.child(`images/${this.state.jobID}/${this.state.licenseID}/${this.state.file.name}`).put(this.state.file).then((snapshot) => {
//                 storageRef.child(`images/${this.state.jobID}/${this.state.licenseID}/${this.state.file.name}`).getDownloadURL().then((url)=>{
//                     let jobID = this.state.jobID
//                     let licenseID = this.state.licenseID
//                     // createImage
//                     // jobID
//                     // licenseID
//                     // url
//                     axios.post( 
//                         'https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',
//                         {
//                           'action': 'uploadImage',
//                           'data': {
//                               jobID : jobID,
//                               licenseID : licenseID,
//                               url : url
//                           },
//                         } 
//                       ).then((res)=>{
//                         let dataArr = this.state.dataArr
//                         dataArr.push({
//                             jobID : jobID,
//                             licenseID : licenseID,
//                             url : url
//                         })
//                         this.setState({
//                             ...this.state,
//                             file: null,
//                             jobID : '',
//                             licenseID : '',
//                             dataArr : dataArr,
//                             isLoading : false,
//                         },()=>{
//                             alert(`อัพโหลดเรียบร้อย Order No : ${jobID} LicenseID : ${licenseID}`)
//                         })
//                     })
//                 })
//             }).catch(()=>{
//                 this.setState({
//                     ...this.state,
//                     isLoading : false,
//                 },()=>{
//                     alert('เกิดข้อผิดพลาด กรุณาลองใหม่')
//                 })
//             })
//         }else{
//             alert('กรุณาอัพโหลดรูปภาพ')
//         }
//     }

//     render() {
//         return (
//             <Container style={{width:'100%',alignContent:'center',textAlign:'center',fontSize:'22px'}}>
//                 <div style={{marginTop:'3%'}}>
//                 <a href='http://178.128.220.206'>กลับหน้าหลัก</a>
//                 <h1>อัพโหลดรูปภาพ CheckWeight</h1>
//                 <InputGroup onChange={this.handleInput}  className="mb-3">
//                     <FormControl
//                     value={this.state.jobID}
//                     id='jobID'  
//                     placeholder="กรุณากรอกเลข Order No เช่น 2625 "
//                     aria-label="Username"
//                     aria-describedby="basic-addon1"
//                     />
//                 </InputGroup>
//                 <InputGroup onChange={this.handleInput}  className="mb-3">
//                     <FormControl
//                     value={this.state.licenseID}
//                     id='licenseID'  
//                     placeholder="กรุณากรอกเลข license No เช่น 0308116302132"
//                     aria-label="Username"
//                     aria-describedby="basic-addon1"
//                     />
//                 </InputGroup>
//                 <InputGroup onChange={this.handleChange}  className="mb-3">
//                     <FormControl
//                     type='file'
//                     aria-label="Username"
//                     aria-describedby="basic-addon1"
//                     />
//                 </InputGroup>

//                 <Button onClick={this.uploadToFirebase}>Upload</Button>
//                 <br></br>
//                 <br></br>

//                 <Table bordered hover >
//                         <thead>
//                           <tr>
//                             <th> Order No </th>
//                             <th> License No</th>
//                             <th> Link </th>
//                           </tr> 
//                         </thead>
//                         {this.state.dataArr.map((d)=>{
//                     return(
//                         <tbody>
//                             <tr >
//                                 <td>{d['jobID']}</td>
//                                 <td>{d['licenseID']}</td>
//                                 <td><a href={d['url']}> แสดง </a></td>
//                             </tr>
//                         </tbody>
//                       )})}
//                 </Table>
//             </div>
//             {(()=>{
//                 if(this.state.isLoading){
//                    return(<Loading title={'กำลังอัพโหลดรูป'}/>)
//                 }else{
//                     return(<div></div>)
//                 }
//             })()}
//             </Container>
//         ); 
//     }
// }

// export default UploadCheckWeight;

